/**
 * Map control helpers (Stage 5 §5.1).
 *
 * Pure functions extracted from MapView so the zoom-tier math is unit-testable
 * without a live Cesium viewer (the viewer + ScreenSpaceEventHandler wiring is
 * verified in-browser instead).
 */

/** Each double-click descends to this fraction of the current altitude — one
 *  "tier" in. 0.5 ≈ halving the eye height per double-click. */
export const ZOOM_IN_FACTOR = 0.5;

/** Floor (metres) so repeated double-clicks can't drive the camera underground
 *  or into a degenerate sub-metre altitude. */
export const MIN_ZOOM_HEIGHT_M = 150;

/**
 * The altitude (metres) to fly to when the operator double-clicks: one tier
 * closer, clamped to MIN_ZOOM_HEIGHT_M. Non-finite / non-positive input (a
 * camera at the centre of the globe, etc.) falls back to the floor so the
 * caller always gets a sane height.
 */
export function nextZoomHeight(currentHeightM: number): number {
  if (!Number.isFinite(currentHeightM) || currentHeightM <= 0) return MIN_ZOOM_HEIGHT_M;
  return Math.max(currentHeightM * ZOOM_IN_FACTOR, MIN_ZOOM_HEIGHT_M);
}
